/*
 * Copyright (c) 2022
 * 
 * Created Date: Thursday, September 22nd 2022, 2:02:24 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import React from 'react'
import { MdArrowRightAlt } from 'react-icons/md'
import Loader from 'components/Common/Loader'

const LoginButton = ({ text = '', onPress = () => { }, isLoading = false, disabled = false }) => {
    const onPrePressed = () => {
        if (isLoading || disabled) return

        return onPress()
    }

    return <button type='submit' className={`auth-login-button ${disabled ? `disabled` : ''}`} onClick={onPrePressed}>
        <p>{text}</p>
        {isLoading ? <Loader.ButtonLoader /> : <MdArrowRightAlt id='auth-login-icon' size={20} color='white' />}
    </button>
}

export default LoginButton
